import { Checkbox, CheckboxProps } from "@mui/material";
import { BarekamIcon, IconVariants } from "../icon/barekam-icon";

const BarekamCheckbox = (props: CheckboxProps) => {
    return (
        <Checkbox icon={<BarekamIcon variant={IconVariants.checkbox} isChecked={false} />}
            checkedIcon={<BarekamIcon variant={IconVariants.checkbox} isChecked={true} />}
            indeterminateIcon={<BarekamIcon variant={IconVariants.checkbox} indeterminate={true} />}
            {...props} />
    );
}

export default BarekamCheckbox;
